import LastFollow from './LastFollow';

// Every retired path here has to name the page that absorbed it, not the file
// it used to be. Firebase 301s these server-side before React loads, so a wrong
// entry is normally invisible -- and then it is a 404 the one time the redirect
// does not fire. /blog.html, /last-follow.html and
// /recent-instagram-followings.html no longer exist; /last-follow is gone from
// the map entirely because it resolves to the home page, which this app renders.
const staticRoutes = {
  '/about': '/about.html',
  '/about-lastfollow': '/about.html',
  '/ai-discovery': '/about.html',
  '/blog': '/guides/index.html',
  '/help': '/support.html',
  '/help-tr': '/support.html',
  '/how-it-works': '/how-it-works.html',
  '/how-to-see-recent-instagram-followings': '/how-to-see-recent-instagram-followings.html',
  '/instagram-following-order': '/how-to-see-recent-instagram-followings.html',
  '/privacy': '/privacy.html',
  '/privacy-tr': '/privacy-tr.html',
  '/recent-follow': '/recent-follow.html',
  '/recent-instagram-followers': '/recent-instagram-followers.html',
  '/recent-instagram-followings': '/how-to-see-recent-instagram-followings.html',
  '/support': '/support.html',
  '/terms': '/terms.html',
};

const localizedRoutePattern = /^\/(tr|de|ar|fr|pt|es|it)(\/.*)?$/;
const guideRoutePattern = /^\/guides(\/.*)?$/;

function getStaticTarget(cleanPath) {
  if (staticRoutes[cleanPath]) {
    return staticRoutes[cleanPath];
  }

  const guideMatch = cleanPath.match(guideRoutePattern);

  if (guideMatch) {
    const suffix = guideMatch[1] || '';
    return suffix ? `/guides${suffix}.html` : '/guides/index.html';
  }

  const localizedMatch = cleanPath.match(localizedRoutePattern);

  if (!localizedMatch) {
    return null;
  }

  const locale = localizedMatch[1];
  const suffix = localizedMatch[2] || '';

  if (!suffix || suffix === '/') {
    return `/${locale}/index.html`;
  }

  return `/${locale}${suffix}.html`;
}

function App() {
  const cleanPath = window.location.pathname.replace(/\/$/, '') || '/';
  const staticTarget = getStaticTarget(cleanPath);

  if (staticTarget) {
    window.location.replace(`${staticTarget}${window.location.search}${window.location.hash}`);
    return null;
  }

  return <LastFollow />;
}

export default App;
